import { bunja } from 'bunja';
import { useBunja } from 'bunja/react';

import { dialog } from '@flipster/react/design-system/dialog';
import { RouterScope } from '@flipster/react/providers/route';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import webviewHandler from '@flipster/utils/webview-handler';

import { authBunja } from '../auth/state';
import { KycDialog } from '../kyc/dialog';

const loginKycGuardBunja = bunja(() => {
  const router = bunja.use(RouterScope);
  const store = bunja.use(JotaiStoreScope);
  const { isLoggedInAtom, isValidKycAtom } = bunja.use(authBunja);

  function guardLoginAndKyc(onPass: () => void) {
    if (!store.get(isLoggedInAtom)) {
      webviewHandler.postMessage({ action: 'link', params: { page: 'login' } }, () => router.push('/login'));
      return;
    }
    if (!store.get(isValidKycAtom)) {
      dialog.open(({ isOpen, promise }) => <KycDialog isOpen={isOpen} close={promise.resolve} />);
      return;
    }
    onPass();
  }

  return { guardLoginAndKyc };
});
loginKycGuardBunja.debugLabel = 'loginKycGuardBunja';

export function useLoginKycGuard() {
  const { guardLoginAndKyc } = useBunja(loginKycGuardBunja);
  return guardLoginAndKyc;
}
